import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { WhatsNew } from 'components/WhatsNew/WhatsNew';
import { WhatsNewLoader } from 'components/WhatsNew/WhatsNewLoader/WhatsNewLoader';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';

export const WhatsNewPage = () => {
  const { introducerId } = useIntroducerData();

  return (
    <BaseLayout
      pageTitle={t`What's new | Introducer Portal`}
      contentPadding={false}
    >
      {introducerId ? (
        <WhatsNew introducerId={introducerId} />
      ) : (
        <WhatsNewLoader />
      )}
    </BaseLayout>
  );
};
